const BASE = process.env.REACT_APP_API_BASE_URL || '';

async function jsonFetch(path, init = {}) {
  const { body, headers, ...rest } = init;

  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    // keep caller method/other options
    ...rest,
    headers: {
      ...(headers || {}),
      ...(body && !((headers || {})['Content-Type']) ? { 'Content-Type': 'application/json' } : {}),
    },
    body: body != null ? JSON.stringify(body) : undefined,
  });

  let data = null;
  try { data = await res.json(); } catch { data = null; }

  if (!res.ok) {
    const msg = (data && (data.message || data.error)) || `Request failed: ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

export const API = {
  // Auth
  checkAuth: () => jsonFetch('/check-auth'),
  loginPortal: () => jsonFetch('/login'),
  ping: () => jsonFetch('/ping'),

  // Projects and timelogs
  fetchProjects: () => jsonFetch('/projects'),
  fetchProjectsTimelogs: () => jsonFetch('/timelogs'),
  fetchProjectsTimelogsWeek: (start) => jsonFetch(`/timelogs/week?start=${encodeURIComponent(start)}`),
  fetchPeopleTimelogs: () => jsonFetch('/people-timelogs'),

  // Zoho Projects timelogs
  createTimelog: (payload) => jsonFetch('/send-timelog', { method: 'POST', body: payload }),
  createTimelogsBulk: (payload) => jsonFetch('/send-timelogs-bulk', { method: 'POST', body: payload }),
  updateTimelog: (payload) => jsonFetch('/update-timelog', { method: 'PUT', body: payload }),
  deleteTimelog: (payload) => jsonFetch('/delete-timelog', { method: 'DELETE', body: payload }),
  deleteTimelogsBulk: (payload) => jsonFetch('/delete-timelogs-bulk', { method: 'DELETE', body: payload }),

  // Tasks by project
  fetchTasksByProject: (projectId) =>
    jsonFetch(`/get-tasks-by-project?projectId=${encodeURIComponent(projectId)}`),

  // Recommended tasks (ZRM - across all projects)
  fetchRecommendedTasks: () => jsonFetch('/recommended-tasks'),

  // Zoho People timelogs
  createPeopleTimelog: (payload) => jsonFetch('/send-timelog-people', { method: 'POST', body: payload }),
  updatePeopleTimelog: (payload) => jsonFetch('/update-people-timelog', { method: 'PUT', body: payload }),
  deletePeopleTimelog: (payload) => jsonFetch('/delete-people-timelog', { method: 'DELETE', body: payload }),

  // User preferences
  getUserViewPreference: () => jsonFetch('/user/view-preference'),
  saveUserViewPreference: (view) => jsonFetch('/user/view-preference', { method: 'POST', body: { view } }),

  // Bonus dashboard
  getMyBonus: () => jsonFetch('/zrm/bonus/me'),
  getBonusDashboard: () => jsonFetch('/zrm/dashboard'),
  reportProgress: (payload) => jsonFetch('/zrm/progress/me', { method: 'POST', body: payload }),
  getLeaderboard: () => jsonFetch('/zrm/leaderboard'),
  getBoss: (projectId) => jsonFetch(`/zrm/boss/${projectId}`),
  castSpell: (projectId, myHours) => jsonFetch(`/zrm/boss/${projectId}/cast`, { method: 'POST', body: { myHours } }),

  // Admin: user roles (Udvikler / Projektleder)
  fetchAdminUsers: () => jsonFetch('/admin/users'),
  setUserRole: (zuid, role) =>
    jsonFetch(`/admin/users/${encodeURIComponent(zuid)}/role`, { method: 'POST', body: { role } }),
};